import React, { useState } from "react";
import { Modal, Box, Typography, useTheme } from "@mui/material";
import classic from 'packages/novous_web/src/assets/icons/classic.svg';
import Traffic from 'packages/novous_web/src/assets/icons/Traffic.svg';
import Satellite from 'packages/novous_web/src/assets/icons/Satellite.svg';
import Terrain from 'packages/novous_web/src/assets/icons/Terrain.svg';
import CustomIconButton from "./CustomIconButton";

interface MapViewModalProps {
    open: boolean;
    onClose: () => void;
    mapType: "roadmap" | "satellite" | "terrain" | "hybrid";
    onSelect: (mapType: "roadmap" | "satellite" | "terrain" | "hybrid") => void;
}

const mapOptions: { name: string, icon: any, type: "roadmap" | "satellite" | "terrain" | "hybrid" }[] = [
    { name: "Classic", icon: classic, type: "roadmap" },
    { name: "Traffic", icon: Traffic, type: "hybrid" },
    { name: "Satellite", icon: Satellite, type: "satellite" },
    { name: "Terrain", icon: Terrain, type: "terrain" }
];

const MapViewModal: React.FC<MapViewModalProps> = ({ mapType, open, onClose, onSelect }) => {
    const [selectedMap, setSelectedMap] = useState<"roadmap" | "satellite" | "terrain" | "hybrid">("roadmap");
    const theme = useTheme();
    const handleSelect = (mapType: "roadmap" | "satellite" | "terrain" | "hybrid") => {
        setSelectedMap(mapType);
    };

    const handleApply = () => {
        onSelect(selectedMap);
        onClose();
    };

    const handleClose = ()=>{
        setSelectedMap(mapType);
        onClose();
    }

    return (
        <Modal open={open} onClose={onClose} aria-labelledby="map-view-modal">
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    textAlign: "center",
                }}
            >
                <div className="flex flex-col gap-4">
                    <Typography variant="h6">Select Map View</Typography>

                    {/* Map Options */}
                    <div className="flex flex-col gap-2">
                        <Typography variant="body1">Map Style</Typography>
                        <div className="flex gap-6">
                            {mapOptions.map((item) => (
                               <div
                               key={item.name}
                               className="flex flex-col items-center gap-2 cursor-pointer"
                               onClick={() => handleSelect(item.type)}
                           >
                               <div
                                   className={`rounded-md transition-all duration-200 border-4`}
                                   style={{
                                       borderColor: selectedMap === item.type ? theme.palette.primary.main : "transparent",
                                       borderWidth: selectedMap === item.type ? "4px" : "2px",
                                       borderRadius: selectedMap === item.type ? "14px" : ""
                                   }}
                               >
                                   <img src={item.icon} width={80} height={80} alt={item.name} />
                               </div>
                           
                               <Typography variant="button">{item.name}</Typography>
                           </div>
                           
                            ))}
                        </div>
                    </div>

                    {/* Buttons */}
                    <div className="flex justify-between gap-2">
                        <CustomIconButton
                            text="Cancel"
                            background="transparent"
                            outline={true}
                            padding="0px"
                            variant="outlined"
                            onClick={handleClose}
                        />
                        <CustomIconButton
                            text="Apply"
                            padding="0px"
                            variant="contained"
                            onClick={handleApply}
                        />
                    </div>
                </div>
            </Box>
        </Modal>
    );
};

export default MapViewModal;
